<div class="screen-capture-animation-dialog">
  <div class="header">We need screen sharing access to enable nudges.</div>
  <div class="section">
    <div class="animation">
      <lottie-player src="../../../../assets/lottieFiles/screen-share.json" background="transparent" speed="1" loop
        autoplay>
      </lottie-player>
    </div>
    <div class="text">
      when you provide the screensharing access, Netcore Product Experience accurately stores the location of your
      custom
      nudge on your
      website.
    </div>
    <div class="text">
      Please note that Netcore Product Experience does not collect any usage data.
    </div>
  </div>
  <div class="dialog-action">
    <button mat-button class="secondary-cta-btn" (click)="closeModal()">I Understand</button>
  </div>
</div>
